import { EFinancingProductId } from '@/types'

export enum ELoanProductCollapsing {
  ORDER = 'ORDER',
  CALC = 'CALC',
  CONSULT = 'CONSULT',
}

export const LOAN_PRODUCTS_HAS_ONLY_CONSULT_FORM: EFinancingProductId[] = [EFinancingProductId.SBERPAY]
